import React from 'react'
import { Modal, Frame } from '@react95/core'
import { Box, Heading, Text } from '@pancakeswap/uikit'
import { Nwnp32FolderIcon, Issue, Awfxex32Info, Notepad2 } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'
import { AutoRow } from 'components/Layout/Row'
import PrivacyPolicyModal from './PrivacyPolicyModal'
import XXXModal from './XXXModal'

const HelpModal = ({ close, modalStyle, frameStyle, iconStyle, iconContainerStyle, toggleHowToBuy }) => {
  const { t } = useTranslation()
  const [privacyPolicy, togglePrivacyPolicy] = React.useState(false)
  const [xxx, setXXX] = React.useState(false)

  const closePrivacyPolicy = () => togglePrivacyPolicy(false)
  const closeXXX = () => setXXX(false)

  return (
    <>
      {privacyPolicy && (
        <PrivacyPolicyModal close={closePrivacyPolicy} modalStyle={modalStyle} frameStyle={frameStyle} />
      )}
      {xxx && <XXXModal close={closeXXX} modalStyle={modalStyle} frameStyle={frameStyle} />}
      <Modal
        defaultPosition={{ x: 6, y: 4 }}
        icon={<Issue variant="16x16_4" />}
        title="Help"
        closeModal={close}
        width="90vw"
        height="90vh"
        style={modalStyle}
        buttons={[{ value: 'Ok', onClick: close }]}
      >
        <Frame style={frameStyle}>
          <Heading scale="xl" mb="16px" mt="16px">
            {t(`Help`)}
          </Heading>

          <Text fontSize="18px" mb="24px">
            {t(`Check out some useful links to learn more about the project and how to use it:`)}
          </Text>

          <AutoRow justify="center" align="center">
            <Box
              style={{
                width: '154px',
                textAlign: 'center',
                marginLeft: '16px',
                marginTop: '16px',
                marginBottom: '16px',
                cursor: 'pointer',
              }}
              onClick={() => toggleHowToBuy(true)}
            >
              <Awfxex32Info style={iconStyle} />
              <Text color="black" fontSize="20px" textAlign="center">
                {t('How to Buy')}
              </Text>
            </Box>

            <Box style={{ ...iconContainerStyle, width: '150px' }} onClick={() => togglePrivacyPolicy(true)}>
              <Notepad2 style={iconStyle} />
              <Text color="black" fontSize="20px" textAlign="center">
                {t('Privacy Policy')}
              </Text>
            </Box>
            <Box onClick={() => setXXX(true)} style={iconContainerStyle}>
              <Nwnp32FolderIcon style={iconStyle} />
              <Text color="black" fontSize="20px" textAlign="center">
                {t('XXX')}
              </Text>
            </Box>
          </AutoRow>
        </Frame>
      </Modal>
    </>
  )
}

export default HelpModal
